/**
 * Returns the number of billing units (sites, domains, URLs) for the current tariff.
 *
 * @param product
 * @param [cart]
 * @return {number}
 */
export default (product, cart) => {
    let count;
    cart = cart || {};

    switch (product?.product_id || product?.tariff?.product_id) {
        // DB.
        case 2:
            count = product?.tariff?.checks ?? 0;
            break;
        // SSL.
        case 5:
            count = cart?.domains?.length || 1; // If no domains - then consider as bought of new domain.
            break;
        // doBoard.
        case 7:
            count = product?.tariff?.projects ?? 0;
            break;
        default:
            count = product?.tariff?.services ?? 0;
            break;
    }

    return count ?? 0;
};
